module.exports = __webpack_public_path__ + "img/Qatar.998a1fb1.gif";